import React from 'react';
import { Steps } from '@b-design/fusion';
import $i18n from '@/i18n';
import './index.less';
interface Props {
  currentStep: string | (string | null)[] | null;
}
const Left: React.FC<Props> = (props) => {
  // const [currentStep, setCurrentStep] = React.useState(0);
  const { currentStep } = props;
  return (
    <div className="space-container">
      <div className="space-steps">
        <Steps
          current={Number(currentStep)}
          shape="circle"
          stretch
          labelPlacement="hoz"
          direction="ver"
        >
          <Steps.Item
            key={1}
            title={$i18n.get({
              id: 'aopf.pages.miniapp.settleIn.Space.Registration',
              dm: '空间注册',
            })}
          />
          <Steps.Item
            key={2}
            title={$i18n.get({
              id: 'aopf.pages.miniapp.settleIn.Enterprise.Information',
              dm: '企业信息',
            })}
          />
          <Steps.Item
            key={3}
            title={$i18n.get({
              id: 'aopf.pages.miniapp.settleIn.Waiting.Entry',
              dm: '等待进入',
            })}
          />
          <Steps.Item
            key={4}
            title={$i18n.get({
              id: 'aopf.pages.miniapp.settleIn.Start.Develop',
              dm: '开始开发',
            })}
          />
        </Steps>
      </div>
      {!window.__SUPERAPP_CONFIG__?.isConfiguredDomain && <div className={`stepImg-${currentStep}`} />}

      {/* <div
              style={{
                margin: '24px 0',
                width: '100%',
                height: '120px',
                fontFamily: 'HelveticaNeue',
                backgroundColor: '#f5f6f7',
                color: '#808084',
                fontSize: '14px',
                letterSpacing: '0.25px',
                lineHeight: '120px',
                textAlign: 'center',
              }}
            >
              {`Step${currentStep + 1} Content`}
            </div> */}
      {/* <div>
              <Button
                disabled={currentStep == 0}
                type="primary"
                onClick={() => setCurrentStep(currentStep < 1 ? 0 : currentStep - 1)}
                style={{ marginRight: '16px' }}
              >
                Next
              </Button>
              <Button
                disabled={currentStep == 2}
                type="secondary"
                onClick={() => setCurrentStep(currentStep > 1 ? 2 : currentStep + 1)}
              >
                Previous
              </Button>
            </div> */}
    </div>
  );
};

export default Left;
